class PaymentDetailsController {

  constructor(paymentGatewayService, paymentTokenService, cardActionService) {
    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
    this.cardActionService = cardActionService;
  }

  $onInit () {
    if (!this.gateway) {
      return this.handleError([ 'Please contact us for help.' ], true, 'No gateway set up.');
    }

    return this.paymentGatewayService.mount(this.gateway)
      .then(response => {
        if (response) {
          this.paymentTokenService.setCreateToken(response.createToken);
          this.cardActionService.setHandleCardAction(response.createAction);
        }
      })
      .catch(() => {
        return this.handleError([ 'Please contact us for help.' ], true, 'Fail setting up gateway');
      });
  }

  handleError (error, report, text) {
    this.errorCallback({ error, report, text });
  }
}

PaymentDetailsController.$inject = [ 'paymentGatewayService', 'paymentTokenService', 'cardActionService' ];

export default PaymentDetailsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/controllers/payment.details.controller.js